module.exports = __webpack_public_path__ + "media/images/iconSocialMail--dark-de55359a65705ee0b4cf3aa7ca4c31c7.png";